import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { AccessTime } from '@mui/icons-material';
import * as React from 'react';
import { getHoursString, getMinutesString, getTimeString } from 'utils';

interface TimeSelectorProps {
  label?: string;
  initialValue?: Date;
  onChange?: Function;
}

export const TimeSelector: React.FC<TimeSelectorProps> = (props) => {
  const { label = 'hh:mm', initialValue = new Date(), onChange = () => {} } = props;
  const [hValue, setHValue] = React.useState<number>(initialValue.getHours());
  const [mValue, setMValue] = React.useState<number>(initialValue.getMinutes());
  const [value, setValue] = React.useState<Array<string>>([]);

  const hArray = Array.from(Array(24).keys());
  const mArray = Array.from(Array(60).keys());

  React.useEffect(() => {
    const newValue = getTimeString({ hours: hValue, minutes: mValue });
    const time = new Date();
    time.setHours(hValue);
    time.setMinutes(mValue);

    setValue([newValue]);
    onChange(time);
  }, [hValue, mValue]);

  return (
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        multiple
        label={label}
        renderValue={(value) => <Box>{value}</Box>}
        IconComponent={AccessTime}
        sx={{
          '& .MuiSvgIcon-root': {
            right: '12px',
          },
          '& .MuiSelect-iconOpen': {
            transform: 'rotate(0deg)',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
          }}
        >
          <Box
            sx={{
              width: '50%',
              maxHeight: 200,
              overflow: 'scroll',
            }}
          >
            {hArray.map((hItem) => (
              <MenuItem
                key={`hh-${hItem}`}
                value={hItem}
                selected={hItem === hValue}
                onClick={() => {
                  setHValue(hItem);
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        minWidth: 32,
                      }}
                    >
                      {getHoursString(hItem).hoursString}
                    </Box>
                    <Typography color="textSecondary">h</Typography>
                  </Box>
                  <Box>
                    <Typography color="textSecondary">{getHoursString(hItem).a}</Typography>
                  </Box>
                </Box>
              </MenuItem>
            ))}
          </Box>

          <Box
            sx={{
              width: '50%',
              maxHeight: 200,
              overflow: 'scroll',
            }}
          >
            {mArray.map((mItem) => (
              <MenuItem
                key={`mm-${mItem}`}
                value={mItem}
                selected={mItem === mValue}
                onClick={() => {
                  setMValue(mItem);
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      minWidth: 32,
                    }}
                  >
                    {getMinutesString(mItem)}
                  </Box>
                  <Typography color="textSecondary">m</Typography>
                </Box>
              </MenuItem>
            ))}
          </Box>
        </Box>
      </Select>
    </FormControl>
  );
};
